module.exports = __webpack_public_path__ + "img/aruba.a9a0ef15.svg";